import { styled } from 'linaria/react';
import { h, FunctionalComponent } from 'preact';
import { css } from 'linaria';

interface SpinnerProps {
	size?: number;
	strokeWidth?: number;
	className?: string;
	fill?: {
		primary: string;
		secondary: string;
	}
}

export const Spinner: FunctionalComponent<SpinnerProps> = (props) => {
	const {
		size = 60,
		strokeWidth = 1,
		fill = {
			primary: 'var(--primary-color)',
			secondary: 'transparent',
		},
		className,
	} = props;

	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 50 50"
			className={[spinner, className].join(' ')}
		>
			<circle
				cx="25"
				cy="25"
				r="24"
				fill="none"
				stroke={fill.secondary}
				strokeWidth={strokeWidth}
			/>
			<circle
				cx="25"
				cy="25"
				r="24"
				fill="none"
				stroke={fill.primary}
				strokeWidth={strokeWidth}
				strokeDashoffset='34'
				strokeDasharray='100%, 245%'
				className="semicircle"
			/>
		</svg>
	);
};

export const SpinnerContainer = styled('div')`
	flex: 1;
	flex-direction: column;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const spinner = css`
   	animation: spin 1s ease-in-out infinite;

	@keyframes spin {
	    from {
	        transform:rotate(0deg);
	    }
	    to {
	        transform:rotate(360deg);
	    }
	}
`;
